export const signUp = async (user: any): Promise<any> => {
  const url = 'https://6399kkay5c.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage/sign-up';
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(user)
    });
    const body = await response.json();
    if (response.status !== 200) {
      throw body;
    }
    return body.data;
  } catch (error) {
    throw error;
  }
};
